import { Field, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';

export type Column = {
  id: string;
  title: Field<string>;
  backgroundOddCells: Field<string>;
  backgroundEvenCells: Field<string>;
  width: Field<string>;
  hideTitleOnMobile: Field<boolean>;
};

export type RichTextCellFields = {
  id: string;
  content: RichTextField;
  colspan: Field<number>;
};

export type IconCellFields = {
  id: string;
  icon: Field<string>;
  label: Field<string>;
};

export type RowFields = {
  id: string;
  cells: (RichTextCellFields | IconCellFields)[];
};
